import { Component } from "react";
import config from "../config";
import { clearSessionLockCookies } from "../services/sessionLockService";

export function buildLogoutRedirectUrl(logoutUrl, returnUrl) {
  return `${logoutUrl}?from=${encodeURIComponent(returnUrl)}`;
}

class Logout extends Component {
  componentDidMount() {
    clearSessionLockCookies();

    if (process.env.NODE_ENV === "production") {
      const returnUrl =
        process.env.REACT_APP_LOGOUT_RETURN_URL || window.location.origin;

      window.location = buildLogoutRedirectUrl(
        config.loginPortal.logoutUrl,
        returnUrl,
      );
    }
  }
  render() {
    return null;
  }
}

export default Logout;
